module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      width: _vm.image.view.width + _vm.slidePadding + 'px',
      height: _vm.image.view.height + 'px',
      marginRight: _vm.gutterRight + 'px',
      marginTop: _vm.windowMargin + 'px'
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('img', {
    staticClass: "project-image",
    staticStyle: {
      "opacity": "0"
    },
    style: ({
      width: _vm.image.view.width + 'px',
      height: _vm.image.view.height + 'px',
      marginTop: _vm.marginTop + 'px'
    }),
    attrs: {
      "src": _vm.imagePath,
      "data-src": _vm.src
    }
  }), _vm._v(" "), (_vm.layout.type == 'large') ? _c('a', {
    staticClass: "download-trigger-container",
    on: {
      "click": _vm.download
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/HMJ-Download.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-overlay",
    style: ({
      width: _vm.image.view.width + 'px',
      height: _vm.image.view.height + 'px',
      marginTop: _vm.marginTop + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "image-overlay-content",
    style: ({
      width: _vm.image.view.width + 'px',
      height: _vm.image.view.height + 'px',
      marginTop: _vm.marginTop + 'px'
    })
  }, [_c('div', {
    staticClass: "overlay-content-cell"
  }, [_c('h2', {
    staticClass: "info-title",
    class: {
      centered: _vm.hideInfoText
    }
  }, [_vm._v(_vm._s(this.project.title[_vm.lang]))]), _vm._v(" "), _c('p', {
    staticClass: "info-text",
    class: {
      hidden: _vm.hideInfoText
    }
  }, [_vm._v("\n        " + _vm._s(this.project.text[_vm.lang].description) + "\n        ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-358cb206!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projectImage.vue
// module id = 185
// module chunks = 2